import { Box, Typography, TextField, Button, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import COLORS from '../../../../constants/colors';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; 
import baseURL from '../config'; 
import Header from './Header';
import { toast } from 'react-toastify';
import Footer from '../../user/Reusbale/Footer'

const AdminLogin = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!formData.email || !formData.password) {
            toast.error('Email and password are required!');
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${baseURL}/auth/admin/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include', 
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Invalid credentials');
            }

            toast.success('Admin login successful!');


            setTimeout(() => navigate('/admin/dashboard'), 1000);
        } catch (error) {
            toast.error(error.message);

        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            <Header />
            <Box sx={{ py: 3, px: 3, maxWidth: 400, margin: '0 auto', mt: 8, textAlign: 'center' }}>
                <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={2}>
                    Admin Login
                </Typography>
                <Typography variant="body1" color={COLORS.text} mb={4}>
                    Sign in to access the admin panel.
                </Typography>

                <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <TextField
                        name="email"
                        label="Admin Email"
                        variant="outlined"
                        fullWidth
                        value={formData.email}
                        onChange={handleChange}
                        sx={{
                            mb: 2,
                            '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: '1rem', '& input': { padding: '14px' } },
                        }}
                        InputLabelProps={{ style: { color: COLORS.primary, fontSize: '1rem' } }}
                        InputProps={{
                            style: { color: COLORS.text },
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon icon={faUser} style={{ color: COLORS.primary }} />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        name="password"
                        label="Password"
                        variant="outlined"
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        value={formData.password}
                        onChange={handleChange}
                        sx={{
                            mb: 2,
                            '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: '1rem', '& input': { padding: '14px' } },
                        }}
                        InputLabelProps={{ style: { color: COLORS.primary, fontSize: '1rem' } }}
                        InputProps={{
                            style: { color: COLORS.text },
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon icon={faLock} style={{ color: COLORS.primary }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye}
                                        style={{ fontSize: '15px' }} // smaller icon
                                        />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            backgroundColor: COLORS.primary,
                            color: COLORS.white,
                            borderRadius: '10px',
                            py: 1.2,
                            fontSize: '1rem',
                            boxShadow:0,
                            textTransform: 'none',
                            '&:hover': { backgroundColor: COLORS.secondary },
                        }}
                    >
                        {loading ? <CircularProgress size={22} color="inherit" /> : 'Login'}
                    </Button>
                </Box>

                <Box mt={2} sx={{ textAlign: 'right' }}>
    <Typography variant="body2" color={COLORS.text} mt={1}>
        Forgot password?{' '}
        <Typography
            component="span"
            color={COLORS.primary}
            fontWeight="bold"
            sx={{ cursor: 'pointer', textDecoration: 'none' }}
            onClick={() => navigate('/admin/forgot-password')}
        >
            Reset Password
        </Typography>
    </Typography>

    <Typography variant="body2" color={COLORS.text} mt={2}>
        <Typography
            component="span"
            color={COLORS.primary}
            fontWeight="bold"
            sx={{ cursor: 'pointer', textDecoration: 'none' }}
            onClick={() => navigate('/')}
        >
            &larr; Back to Home
        </Typography>
    </Typography>
</Box>
            </Box>

            <Footer />
        </Box>
    );
};

export default AdminLogin;
